/* Native Shopify GET filters: validate the price pair without changing user-entered values. Supports both the legacy and R32 forms. */
(() => {
  'use strict';
  if (window.__mmCatalogRanges20261002) return;
  window.__mmCatalogRanges20261002 = true;
  const initialized = new WeakSet();
  const initialize = () => {
    document.querySelectorAll('.mm-facet-form, .r32-filter form').forEach(form => {
      if (initialized.has(form)) return;
      const ranges = [...form.querySelectorAll('[data-mm-price-range]')].map(group => ({
        group, min: group.querySelector('[data-mm-price-min]'), max: group.querySelector('[data-mm-price-max]')
      })).filter(range => range.min && range.max);
      if (!ranges.length) return;
      initialized.add(form);
      const validate = () => {
        let invalid = null;
        ranges.forEach(({group, min, max}) => {
          const ordered = min.value === '' || max.value === '' || !Number.isFinite(min.valueAsNumber) || !Number.isFinite(max.valueAsNumber) || min.valueAsNumber <= max.valueAsNumber;
          max.setCustomValidity(ordered ? '' : (group.dataset.mmRangeError || 'The maximum price must be at least the minimum price.'));
          if (!ordered && !invalid) invalid = max;
        });
        return invalid;
      };
      form.addEventListener('input', validate);
      form.addEventListener('change', validate);
      form.addEventListener('submit', event => {
        const invalid = validate();
        if (invalid) { event.preventDefault(); invalid.reportValidity(); invalid.focus(); }
      });
      form.addEventListener('reset', () => setTimeout(validate, 0));
      validate();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();